import React from 'react';
import { Router ,Route, IndexRoute } from 'react-router';
//Import Higher Level Components

//import main Components
import App from './components/App';
//import child Components
import Init from './components/initialisation/Initialisation';
import AppBite from './components/AppBite';
import AppBiteMenu from './components/AppBiteMenu';
export default (
    <Router>
        <Route path="/" component={App}>
            <IndexRoute component={Init}/>
            <Route path="menu" component={AppBiteMenu}/>
            <Route path=":bite_id" component={AppBite}/>


        </Route>
    </Router>
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/